import GreenGoodDesignAwardFrame from "./components/GreenGoodDesignAwardFrame";
import GreenGoodDesignAwardForm from "./components/GreenGoodDesignAwardForm";
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: "/green-good-design-award",
        name: "green-good-design-award",
        redirect: "/green-good-design-award/account",
        meta: {
            auth: true,
            basePath: true,
            award: "greengooddesign",
            awardName: "Green Good Design Award",
        },
        component: GreenGoodDesignAwardFrame,
        children: [
            {
                path: "",
                component: GreenGoodDesignAwardForm,
                name: "green-good-design-award-form",
            },
            ...UserAccountRoutes,
        ],
    },

    /*/future-house-awards*/
];
